import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { MarketplacePurchaseModel, MarketplacePurchaseSearch } from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";


const getMarketplacePurchaseByUser = (model:MarketplacePurchaseSearch): Promise<MarketplacePurchaseModel> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplacePurchase/get-marketplace-purchase?SearchValue=${model.searchValue}&PageNumber=${model.pageNumber}&PageSize=${model.pageSize}&OrderDescending=${model.orderDescending}&UserId=${model.userId}&SortColumn=${model.sortColumn}&AffiliateId=${model.affiliateId}`)
}
export default getMarketplacePurchaseByUser;
